let resumeData = {
    "imagebaseurl":"https://avatars.githubusercontent.com/u/99885734?s=400&u=cf6869ec1850d6d425ca065c2c8e4681f8a23519&v=4",
    "name": "Debashish Sahu",
    "role": "Frontend React JS Developer",
    "linkedinId":"https://www.linkedin.com/in/debashishsahu7/",
    "skypeid": "Your skypeid",
    "roleDescription": "I have expertise in JavaScript, React.js, and diverse technical stacks, delivering seamless user experiences through captivating web applications.",
    "socialLinks":[
        {
          "name":"linkedin",
          "url":"https://www.linkedin.com/in/debashishsahu7/",
          "className":"fa fa-linkedin"
        },
        {
          "name":"github",
          "url":"https://github.com/debashish7862",
          "className":"fa fa-github"
        },
        {
          "name":"skype",
          "url":"/",
          "className":"fa fa-twitter"
        },
        {
          "name":"facebook",
          "url":"https://www.facebook.com/debashish.sahu.794",
          "className":"fa fa-facebook"
        },
        {
          "name":"instagram",
          "url":"https://www.instagram.com/debashishsahu7/",
          "className":"fa fa-instagram"
        },
        {
          "name":"gmail",
          "url":"https://mail.google.com/mail/?to=debashish7862@gmail.com&bcc=admin@example.com&subject=Hey#compose",
          "className":"fa fa-envelope"
        }
      ],
    "aboutme":"I completed my post-graduate studies in Master of Computer Applications in 2022. Currently, I am actively enhancing my skill set by exploring emerging technologies. At present, I am focusing on JavaScript and working towards improving my expertise in front-end development",
    "address":"Bhubaneswar,Odisha,768049,India",
    "website":"debashish7862@gmail.com",
    "education":[
      {
        "UniversityName":"Utkal University",
        "specialization":"Master in Computer Application",
        "MonthOfPassing":"Aug",
        "YearOfPassing":"2022",
        "Achievements":"8.2 CGPA"
      },
      {
        "UniversityName":"Sambalpur University",
        "specialization":"BSc in Computer Science",
        "MonthOfPassing":"Jun",
        "YearOfPassing":"2019",
        "Achievements":"7.0 CGPA"
      }
    ],
    "work":[
      {
        "CompanyName":"Geekster",
        "specialization":"Frontend Internship",
        "MonthOfLeaving":"Jun",
        "YearOfLeaving":"2023",
        "Achievements":"Rect JS Developer Certification"
      },
      {
        "CompanyName":"Geekster",
        "specialization":"MERN Fullstack Developer",
        "MonthOfLeaving":"Aug",
        "YearOfLeaving":"2023",
        "Achievements":"Fullstack Certification"
      }
    ],
    "skillsDescription":"I have skills of ",
    "skills":[
      {
        "skillname":"HTML"
      },
      {
        "skillname":"CSS"
      },
      {
        "skillname":"Java Script"
      },
      {
        "skillname":"Reactjs"
      },
      {
        "skillname":"GIT"
      },
      {
        "skillname":"SQL"
      },
      {
        "skillname":"Java"
      },
      {
        "skillname":"Figma"
      },
      {
        "skillname":"Bootstrap"
      },
     
    ],
    "portfolio":[
      {
        "name":"E-commerce Website",
        "description":"mobileapp",
        "imgurl":"https://ecommerceguide.com/wp-content/uploads/2020/02/India-1Amazon.jpg"
      },
      {
        "name":"Youtube Clone",
        "description":"mobileapp",
        "imgurl":"https://sm.mashable.com/t/mashable_in/news/y/youtube-ro/youtube-rolls-out-big-changes-to-its-desktop-homepage_b5ev.1248.png"
      },
      {
        "name":"Pizza Ordering Website",
        "description":"mobileapp",  
        "imgurl":"https://media.licdn.com/dms/image/D562DAQEuisnrwOAMew/profile-treasury-image-shrink_800_800/0/1685423566718?e=1692687600&v=beta&t=PtDedatDOruHGn3IQkeTPX6VedB2ukV00Q4yCQDZGgA"
      },
      {
        "name":"Reciepe Search App",
        "description":"mobileapp",
        "imgurl":"https://media.licdn.com/dms/image/D562DAQFdGzMcBsBFkQ/profile-treasury-image-shrink_800_800/0/1685423586807?e=1692691200&v=beta&t=a75TCb_2UXh9iEdUWMjO66S_8BdIMJ8gQmQmNw1ZND0"
      }
    ],
    "testimonials":[
      {
        "description":"Technology is a tool for empowerment, not a means of control",
        "name":"Debashish Sahu"
      },
      {
        "description":"The future is digital, but the past is analog, and the present is both",
        "name":"Craig Bruce"
      }
    ]
  }
  
  export default resumeData